// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const haystack = defineModel({
  id: "haystack",
  batchId: "future",
  name: "Haystack",
  tags: ["scenery","haystack","low-poly","age-of-mcp","future"],
  summary: "A stacked haystack — stored fodder for animals over winter.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.36,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.18, 0.26, 0.26, 10), color: "#d9b24a", position: [-0.06, 0.13, 0] },
      { geometry: new THREE.SphereGeometry(0.2, 10, 6, 0, 6.283185, 0, 1.570796), color: "#e8c662", position: [-0.06, 0.26, 0], scale: [1, 0.7, 1] },
      { geometry: new THREE.ConeGeometry(0.07, 0.1, 8), color: "#c9a23f", position: [-0.06, 0.4, 0] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#e8c662", position: [0.134324, 0.118063, 0.105551], rotation: [0.190922, -0.497586, 0.351495] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#bf9836", position: [0.033296, 0.150706, 0.182517], rotation: [0.356167, -1.098259, 0.182059] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#e8c662", position: [-0.134114, 0.263689, 0.221303], rotation: [0.379295, -1.893957, -0.127026] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#bf9836", position: [-0.275904, 0.18823, 0.086793], rotation: [0.149194, -2.759367, -0.371135] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#e8c662", position: [-0.261583, 0.187137, -0.099572], rotation: [-0.177147, -3.600387, -0.358635] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#bf9836", position: [-0.051442, 0.193703, -0.22282], rotation: [-0.399705, -4.750777, 0.015351] },
      { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#e8c662", position: [0.12678, 0.141313, -0.092133], rotation: [-0.176952, -5.824935, 0.358731] },
      { geometry: new THREE.CylinderGeometry(0.21, 0.21, 0.012, 10), color: "#bf9836", position: [-0.06, 0.18, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.12, 0.14), color: "#d4ac46", position: [0.3, 0.06, 0.04], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.12, 0.14), color: "#b8923a", position: [0.32, 0.18, 0.02], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.205, 0.01, 0.02), color: "#bf9836", position: [0.32, 0.18, -0.02], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.205, 0.01, 0.02), color: "#bf9836", position: [0.32, 0.18, 0.06], rotation: [0, -0.1, 0] },
    ],
  animations: [],
});
